import { Component, Input } from '@angular/core';
import connectMenu, {
  MenuItem
} from 'instantsearch.js/es/connectors/menu/connectMenu';
import { filter, tap } from 'rxjs/operators';
import { YesNoMapping } from '../../ALGOLIA_CONFIG';
import { RefinementListService } from '../refinement-list/refinement-list.service';
import { BaseWidget } from '../base-widget';

interface MenuState {
  items: MenuItem[];
  refine: (refinement: string) => void;
}

@Component({
  selector: 'app-kcs-menu',
  templateUrl: './kcs-menu.component.html',
  styleUrls: ['./kcs-menu.component.scss']
})
export class KcsMenuComponent extends BaseWidget<MenuState> {
  @Input()
  attribute: string;

  @Input()
  yesno = false;

  @Input()
  yesnoMapping: YesNoMapping | undefined;

  constructor(private refinementListService: RefinementListService) {
    super();
  }

  ngOnInit() {
    this.refinementListService.refine$
      .pipe(
        tap(d => console.log(d, this.attribute)),
        filter(d => d.attribute === this.attribute)
      )
      .subscribe(detail => {
        this.state.refine(detail.value.toString());
      });

    super.ngOnInit();
  }

  createWidget() {
    return connectMenu(renderState => {
      this.updateState({
        items: renderState.items as MenuItem[],
        refine: renderState.refine
      });
    })({
      attribute: this.attribute,
      transformItems: items => {
        if (this.yesno && items) {
          const yesLabel = this.yesnoMapping ? this.yesnoMapping.yes : 'Yes';
          const noLabel = this.yesnoMapping ? this.yesnoMapping.no : 'No';
          const newitems = [
            {
              count: 0,
              isRefined: false,
              label: yesLabel,
              value: 'true',
              highlighted: 'true'
            },
            {
              count: 0,
              isRefined: false,
              label: noLabel,
              value: 'false',
              highlighted: 'true'
            }
          ];
          newitems.forEach(nitem => {
            const fitem = items.filter(item => item.value === nitem.value)[0];
            if (fitem) {
              nitem.count = fitem.count;
              nitem.isRefined = fitem.isRefined;
              // nitem.highlighted = fitem.highlighted;
            }
          });
          return newitems;
        }
        return items;
      }
    });
  }
}
